import DataRoom from "./DataRoom";

// Accounting data room — same layout as the consulting data room, but with
// Accounting as the primary (unlocked) group and Consulting locked until activated.
export default function AccountingDataRoom() {
  return <DataRoom primary="accounting" />;
}
